<template>
  <nav class="navigation-top">
    <div class="nav-wrapper">
      <div class="container">
        <div class="logo">
          <Widget position="logo"/>
        </div>
        <Widget position="main_menu"/>
      </div>
    </div>
  </nav>
</template>

<script>
  import Widget from '@/components/app/Widget'

  export default {
    name: 'Header',
    components: {
      Widget
    }
  }
</script>
